module.exports = __webpack_public_path__ + "static/img/3351_phase_function_Paper_PointsHejduk_Prediction.0213691.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3351_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Y1Id
// module chunks = 0